import { type ComponentProps, lazy, Suspense } from "react";

/** The fitting text itself loads after the page's first paint; until then its words stand in. */
const Impl = lazy(() =>
  import("./fit-text.ondemand").then((module) => ({ default: module.FitText })),
);

export type FitTextProps = ComponentProps<"span"> & { min?: number; wrap?: boolean };

/** One line of bounded text in a fixed space, fitted by the loaded component. */
export function FitText({ className, children, ...props }: FitTextProps) {
  return (
    <Suspense
      fallback={
        <span
          data-slot="fit-text"
          className={className}
          style={{ display: "block", overflow: "hidden", whiteSpace: "nowrap" }}
        >
          {children}
        </span>
      }
    >
      <Impl className={className} {...props}>
        {children}
      </Impl>
    </Suspense>
  );
}
